// Module
var code = "<div class=\"tab-list\"> <div class=\"tabs\"></div> <div class=\"tab-content\"></div> </div>";
// Exports
export default code;